import React from "react";
import TemplateWrapper from "./TemplateWrapper";
import { Paper, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

function Template({
  label,
  parent,
  parent_name,
  onSubmit,
  smallButton,
}: {
  label: string;
  parent: any;
  parent_name?: string;
  onSubmit: any;
  smallButton?: boolean;
}) {
  const [openTemplate, setOpenTemplate] = React.useState(false);
  console.log("swdgtryju", label);
  return (
    <>
      {openTemplate && (
        <TemplateWrapper
          parent={parent}
          parent_name={parent_name}
          onSubmit={onSubmit}
          setOpenTemplate={setOpenTemplate}
          level={label as any}
        />
      )}
      <Paper
        variant="outlined"
        sx={{
          width: smallButton ? "fit-content" : "100%",
          padding: smallButton ? "8px 10px !important" : "16px",
          borderStyle: "dashed",
          borderColor: "primary.main",
          borderRadius: 2,
          textAlign: "center",
          cursor: "pointer",
          gap: "10px",
          display: "flex",
          flexDirection: "column",
          "&:hover": { bgcolor: "grey.50" },
          boxSizing: "border-box",
        }}
        onClick={() => setOpenTemplate(true)}
      >
        <Typography
          variant="body1"
          fontWeight={600}
          fontSize={"16px"}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "5px",
          }}
        >
          {/* 📄 */}
          <ContentCopyIcon sx={{ height: "21px" }} />{" "}
          {smallButton ? "Template" : "Pick a Template"}
        </Typography>
        {smallButton ? (
          ""
        ) : (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ color: "#6b7280", fontWeight: 500 }}
          >
            Copy {label} from an existing hierarchy
          </Typography>
        )}
      </Paper>
      {/* <CustomIconButton
        sx={{ p: "8px 10px", mr: "10px", textTransform: "unset" }}
        // content={`Clone a ${label}`}
        content={`Clone a ${
          label.charAt(0).toUpperCase() + label.slice(1, -1)
        }`}
        variant="outlined"
        key={"Clone a Template"}
        onClick={() => setOpenTemplate(true)}
      /> */}
    </>
  );
}

export default Template;
